import React from 'react';

const RecentActivity = () => (
  <div className="text-white">Recent Activity Logs</div>
  // Bạn có thể thay thế nội dung này bằng component chi tiết hơn
);

export default RecentActivity;